<script>
import _throttle from 'lodash/throttle'

export default {
  props: {
    anchorList: {
      type: Array,
      default: () => [
        {
          text: '解決方案',
          id: 'profile',
        },
      ],
    },
  },
  data() {
    return {
      scrollTop: 0,
      onScroll: _throttle(() => {
        this.scrollTop = this.getWindowScrollTop()
      }, 100),
      bodyOffsetHeight: document.body.offsetHeight,
      reBodyHeight: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)

    const initBodyOffsetHeight = () => {
      this.$nextTick(() => {
        this.bodyOffsetHeight = document.body.offsetHeight
      })
    }
    initBodyOffsetHeight()
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
    this.reBodyHeight = false
  },
  methods: {
    getWindowScrollTop() {
      let windowScrollTop = 0

      if (typeof window.pageYOffset !== 'undefined') {
        windowScrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        windowScrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        windowScrollTop = document.body.scrollTop
      }
      if (this.reBodyHeight === false) {
        this.reBodyHeight = true
        this.bodyOffsetHeight = document.body.offsetHeight
      }

      return windowScrollTop
    },
  },
}
</script>
<template>
  <div :class="[$style.anchor, { [$style.isActive]: scrollTop > 500 && scrollTop < bodyOffsetHeight - 1200 }]">
    <scrollactive :offset="131" active-class="isActive">
      <ul :class="$style.anchorList">
        <li v-for="(anchorItem, index) in anchorList" :key="index" class="anchorList__item">
          <a :href="`#${anchorItem.id}`" class="anchorList__link scrollactive-item">
            <span class="anchorList__text">
              {{ anchorItem.text }}
            </span>
          </a>
        </li>
      </ul>
    </scrollactive>
  </div>
</template>
<style lang="scss" module>
.anchor {
  position: fixed;
  top: 55%;
  left: -6rem;
  mix-blend-mode: difference;
  opacity: 0;
  transition: left 0.6s, opacity 0.6s;
  transform: translateY(-50%);

  &.isActive {
    left: 2.5rem;
    opacity: 1;
  }

  @include max-xl {
    display: none;
  }

  :global {
  }
}

.anchorList {
  @include list-unstyled;

  :global {
    .anchorList {
      &__item {
      }

      &__link {
        position: relative;
        display: block;
        padding: 0.5rem 1.5rem;
        font-weight: 500;

        &:hover {
          text-decoration: none;

          &::before {
            // background: #4205cd;
            background: #c1c1c1;
          }

          .anchorList {
            &__text {
              opacity: 1;
            }
          }
        }

        &:active {
          .anchorList {
            &__text {
              opacity: 0.9;
            }
          }
        }

        &::before {
          position: absolute;
          top: 50%;
          left: 0;
          width: 8px;
          height: 8px;
          margin-top: -4px;
          content: '';
          // background: $color-gray-3;
          background: #1b1b1b;
          border-radius: 100%;
          // background: #8c8c8c;
          transition: background 0.3s;
        }

        &.isActive {
          &::before {
            background: #fff;
          }

          .anchorList {
            &__text {
              opacity: 1;
            }
          }
        }
      }

      &__text {
        font-size: 1rem;
        color: #fff;
        opacity: 0;
      }
    }
  }
}
</style>
